import CheckIcon from "@mui/icons-material/Check";
import ClearIcon from "@mui/icons-material/Clear";
import MUIRefreshIcon from "@mui/icons-material/Refresh";
import { IconButton, Tooltip } from "@mui/material";

import { ToolbarDeleteIcon, InfoToolbarIconBadge } from "src/common/components/ui/MuiDatatableToolbarStyles";
import { TooltipType } from "src/lib/table/tooltip";

export const VerticalDivider = () => {
  return (
    <span style={{ color: "rgba(0, 0, 0, 0.54)", padding: "8px", fontSize: "25px", verticalAlign: "middle" }}>|</span>
  );
};

export const RefreshIcon = ({ mutate }: { mutate: any }) => {
  return (
    <Tooltip title="Refresh">
      <IconButton aria-label="Refresh" onClick={() => mutate()} color="primary">
        <MUIRefreshIcon />
      </IconButton>
    </Tooltip>
  );
};

export const ClearAllIcon = ({ clear }: { clear: () => void }) => {
  return (
    <Tooltip title="Clear all selected rows">
      <IconButton aria-label="Clear all selected rows" onClick={() => clear()} color="error">
        <ClearIcon />
      </IconButton>
    </Tooltip>
  );
};

export const SelectAllIcon = ({ checkAllForTable }: { checkAllForTable: () => void }) => {
  return (
    <Tooltip title="Select all rows">
      <IconButton aria-label="Select all rows" onClick={() => checkAllForTable()} color="primary">
        <CheckIcon />
      </IconButton>
    </Tooltip>
  );
};

export const DeleteIcon = (tooltipType: TooltipType) => {
  const baseIcon = <ToolbarDeleteIcon />;
  switch (tooltipType) {
    case TooltipType.Invalid:
      return (
        <InfoToolbarIconBadge badgeContent={"!"} color="error">
          {baseIcon}
        </InfoToolbarIconBadge>
      );
    case TooltipType.Deleting:
      return (
        <InfoToolbarIconBadge badgeContent={"!"} color="info">
          {baseIcon}
        </InfoToolbarIconBadge>
      );
    case TooltipType.NoSelection:
    case TooltipType.ValidSelection:
    default:
      return baseIcon;
  }
};
